import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import usePageMeta from "../hooks/usePageMeta";

export default function NotFound() {
  usePageMeta({
    title: "Sidan kunde inte hittas | Trädfällarna Laholm AB",
    description: "404 — sidan du försökte nå finns inte längre.",
  });
  return (
    <section
      data-testid="notfound-page"
      className="section-pad min-h-[60vh] flex items-center"
    >
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="font-heading text-6xl sm:text-7xl font-extrabold text-[#D95D2E] mb-4">
          404
        </div>
        <h1 className="font-heading text-3xl sm:text-4xl font-extrabold text-[#1B2A1E] mb-4">
          Den här sidan finns inte
        </h1>
        <p className="text-[#3a4338] text-lg mb-8">
          Sidan du letar efter är borta, har bytt namn eller har aldrig funnits.
          Du kan alltid gå tillbaka till startsidan.
        </p>
        <Link to="/" className="btn-primary">
          <ArrowLeft className="w-4 h-4" /> Till startsidan
        </Link>
      </div>
    </section>
  );
}
